import * as React from "react";
import * as Scrivito from "scrivito";
import { useEffect } from "react";

const backgroundImage =
  "linear-gradient(rgba(46, 53, 60, 0.7), rgba(46, 53, 60, 0.7)), url(https://long-lasting-assets.scrivitojs.com/scrivito_example_app_js/404_not_found.jpeg)";

const MobileLayout = () => {
  useEffect(() => {
    const statusCode = "status-code=404-not-found";
    const { search } = window.location;

    if (!Scrivito.isEditorLoggedIn() && !search.includes(statusCode)) {
      window.location.search = search ? `${search}&${statusCode}` : statusCode;
    }
  }, []);

  return (
    <React.Fragment>
      <section
        className="bg-dark-image full-height"
        style={{ background: "no-repeat center / cover", backgroundImage }}
      >
        <div className="container">
          <div className="text-center">
            <h2 className="hero-small">
              The System Configurator is available on desktop devices only.
              Please switch to a desktop to continue.
            </h2>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export const MobileLayoutPage = Scrivito.connect(MobileLayout);
